import { formatIsoDay } from '../utils/dateHelpers';

interface NoLongerDeployedBadgeProps {
  /** false = worked the month on screen but is no longer deployed in the project. */
  stillDeployed?: boolean;
  /** Their last day deployed in the project, when known. */
  deployedUntil?: string | null;
}

/**
 * Marks a promoter on a month's Sales & Targets list who has since left the project.
 *
 * A month lists everyone deployed at any point in it, so a past month's figures can
 * still be entered — and its incentive paid — for somebody who is gone now. The
 * wording matches the sheets' "Deployed Till" column. Renders nothing for anyone
 * still deployed.
 */
export default function NoLongerDeployedBadge({ stillDeployed, deployedUntil }: NoLongerDeployedBadgeProps) {
  if (stillDeployed !== false) return null;
  return (
    <span
      className="inline-flex items-center whitespace-nowrap rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600 ring-1 ring-gray-200"
      title="Worked this month, but is no longer deployed in this project"
    >
      {deployedUntil ? `Deployed till ${formatIsoDay(deployedUntil)}` : 'No longer deployed'}
    </span>
  );
}
